import type { CrawlJobStatus } from '@liks/lac-svc-api/esm/models/index';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import {
  LAC_CRAWL_JOBS_PAGE_SIZE,
  lacCrawlMonitorService,
} from '../../../services/LacCrawlMonitorService';
import { lacQueryKeys } from '../lacQueryKeys';

export type LacCrawlJobsQueryFilters = {
  startUrl?: string;
  tenantName?: string;
  fromDate?: string;
  toDate?: string;
  status?: CrawlJobStatus[];
  offset?: number;
  limit?: number;
};

export function useLacCrawlJobsQuery(filters: LacCrawlJobsQueryFilters = {}) {
  const { user } = useAuth();
  const trimmedStartUrl = filters.startUrl?.trim() || undefined;
  const tenantName = filters.tenantName?.trim() || undefined;
  const fromDate = filters.fromDate?.trim() || undefined;
  const toDate = filters.toDate?.trim() || undefined;
  const status =
    filters.status != null && filters.status.length > 0
      ? filters.status
      : undefined;
  const offset = filters.offset ?? 0;
  const limit = filters.limit ?? LAC_CRAWL_JOBS_PAGE_SIZE;

  return useQuery({
    queryKey: lacQueryKeys.crawlJobs({
      startUrl: trimmedStartUrl,
      tenantName,
      fromDate,
      toDate,
      status,
      offset,
      limit,
    }),
    enabled: Boolean(user),
    placeholderData: keepPreviousData,
    refetchInterval: 60_000,
    queryFn: () =>
      lacCrawlMonitorService.listCrawlJobs({
        startUrl: trimmedStartUrl,
        tenantName,
        fromDate,
        toDate,
        status,
        offset,
        limit,
      }),
  });
}
